import { Model } from '../general'

export enum Specification {
  CoWorking = 'multi_person',
  SoundProof = 'sound_proof',
}

export interface Data {
  id: number
  name?: string
  holdtime?: number
  multi_person?: boolean
  sound_proof?: boolean
}

class WorkspaceType extends Model<Data> {
  get name() {
    return this.data.name
  }

  get holdTime() {
    return this.data.holdtime || 0
  }

  get specifications() {
    const specifications: Specification[] = []
    if (this.data.multi_person) specifications.push(Specification.CoWorking)
    if (this.data.sound_proof) specifications.push(Specification.SoundProof)
    return specifications
  }

  get searchText(): string {
    return `${this.name}`
  }
}

export default WorkspaceType
